import { PlusIcon } from "@radix-ui/react-icons";
import clsx from "clsx";
import { FC } from "react";

interface NewSectionButtonProps {
  isDraggingOver: boolean;
  setNewSectionNodeRef: (element: HTMLElement | null) => void;
  sectionId: string;
}

export const NewSectionButton: FC<NewSectionButtonProps> = ({
  isDraggingOver,
  setNewSectionNodeRef,
  sectionId,
}) => (
  <div
    className="h-0 relative z-10"
    data-new-section-target={`before-${sectionId}`}
  >
    <div
      className={clsx(
        `absolute left-0 right-0 -top-2 flex items-center gap-[2px]`,
        isDraggingOver ? "visible" : "invisible"
      )}
      ref={setNewSectionNodeRef}
    >
      <PlusIcon className="w-4 h-4 text-blue-600 stroke-blue-600" />
      <div className="bg-blue-600 h-[2px] rounded-[30px] w-[calc(100%-12px)]" />
    </div>
  </div>
);
